import { useTranslation } from 'next-i18next';
import { useFeatureStrings } from '@/shared/plan/useFeatureStrings';
import { type PlanType } from '@/types';
import { PricingCard } from '../PricingCard';
interface FeaturesProps {
  planType: Exclude<PlanType, 'FREE'>;
  countryCode: string;
}
export const Features = ({
  planType,
  countryCode
}: FeaturesProps) => {
  const {
    t
  } = useTranslation(['common']);
  const featureStrings = useFeatureStrings(countryCode);
  const titles = {
    BASIC: {
      mainTitle: t('common:pricing.pro.usefulFeatures'),
      subTitle: t('common:pricing.pro.includesAllFeatures', {
        plans: 'Free'
      })
    },
    PRO: {
      mainTitle: t('common:pricing.pro.usefulFeatures'),
      subTitle: t('common:pricing.pro.includesAllFeatures', {
        plans: 'Free, Basic'
      })
    }
  };
  return <div className="flex flex-col gap-md rounded-xl border border-alternative bg-white px-xl py-lg" data-sentry-component="Features" data-sentry-source-file="Features.tsx">
      <PricingCard.FeatureTitles mainTitle={titles[planType].mainTitle} subTitle={titles[planType].subTitle} data-sentry-element="unknown" data-sentry-source-file="Features.tsx" />
      <PricingCard.FeatureItemList items={featureStrings[planType].normalFeatures} data-sentry-element="unknown" data-sentry-source-file="Features.tsx" />
      <PricingCard.AiFeatureItemList title={planType === 'BASIC' ? 'QUIZ AI' : t('common:pricing.pro.enhancedQuizAI')} items={featureStrings[planType].aiFeatures} data-sentry-element="unknown" data-sentry-source-file="Features.tsx" />
    </div>;
};